import AffiliateNetworkResource from '@/resources/AffiliateNetworkResource';

export default class AffiliateNetwork {
    constructor() {
        this.Resource = new AffiliateNetworkResource()
    }

    async get () {
        const affiliate = await this.Resource.get()
        return affiliate.data.affiliateNetworks
    }

    async getConnected () {
        const affiliate = await this.Resource.getConnected()
        return affiliate.data.connectedAffiliateNetworks
    }

    async getById (id) {
        const affiliate = await this.Resource.getById(id)
        return affiliate.data.affiliateNetworks[0]
    }

    async getByStatusId (id) {
        const affiliate = await this.Resource.getByStatusId(id)
        return affiliate.data.affiliateNetworks
    }

    async create (credentials, networkId, networkName, websiteId, currency, accountName, accountColor) {
        return await this.Resource.create(JSON.stringify(credentials), networkId, networkName, websiteId, currency, accountName, accountColor)
    }

    async update (credentials, accountId, networkName, networkId, currency, websiteId, accountName, accountColor) {
        return await this.Resource.update(
            JSON.stringify(credentials),
            accountId,
            networkName,
            networkId,
            currency,
            websiteId,
            accountName,
            accountColor
        )
    }

    async delete (websiteId, accountId) {
        return await this.Resource.delete(websiteId, accountId)
    }

    async getNetworks (websiteId, mediaIds) {
        const affiliate = await this.Resource.getConnectedAffiliates(websiteId, mediaIds)
        return affiliate.data.me.websites[0].accounts
    }

    async getConnectedAffiliates (websiteId, mediaIds) {
        const affiliate = await this.Resource.getConnectedAffiliates(websiteId, mediaIds)
        const connectedAffiliates = []

        for (let i = 0; i < affiliate.data.me.websites[0].accounts.length; i++) {
            connectedAffiliates.push(affiliate.data.me.websites[0].accounts[i].affiliateNetwork.id)
        }

        return connectedAffiliates
    }

    async getCredentials (websiteId, mediaIds, affiliateId) {
        const affiliate = await this.Resource.getCredentials(websiteId, mediaIds, affiliateId)
        return affiliate.data.me.websites[0].accounts[0]
    }

    async getMediaIds (websiteId) {
        const affiliate = await this.Resource.getMediaIds(websiteId)
        const mediaIds = []

        for (let i = 0; i < affiliate.data.me.websites[0].medias.length; i++) {
            mediaIds.push(affiliate.data.me.websites[0].medias[i].account_id)
        }

        return mediaIds
    }

    async generatePostback (mediaId) {
        return await this.Resource.generatePostback(mediaId)
    }

    async generateDaisyconOauthUrl (websiteId, state) {
        return await this.Resource.generateDaisyconOauthUrl(websiteId, state)
    }

    async receiveDaisyconOauthToken (code, websiteId) {
        return await this.Resource.receiveDaisyconOauthToken(code, websiteId)
    }

    async setProgramEvent (programEvent) {
        return await this.Resource.setProgramEvent(programEvent)
    }
}
